'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useRef, createContext, useContext, useEffect } from 'react';
import { useStore as useZustandStore } from 'zustand';
import { createStore } from 'zustand/vanilla';
export function createContextStore() {
    const Context = createContext(undefined);
    const Provider = ({ initializer, children }) => {
        const storeRef = useRef();
        if (!storeRef.current) {
            storeRef.current = createStore()(initializer);
        }
        return _jsx(Context.Provider, { value: storeRef.current, children: children });
    };
    function useStore() {
        const store = useContext(Context);
        if (!store) {
            throw new Error('useStore must be used within a Provider');
        }
        return useZustandStore(store);
    }
    function useStoreApi() {
        const store = useContext(Context);
        if (!store) {
            throw new Error('getStore must be used within a Provider');
        }
        return store;
    }
    function SyncPropWithStore({ name, value, onChange, }) {
        const storeApi = useStoreApi();
        useEffect(() => {
            if (value !== undefined) {
                storeApi.setState(state => ({ ...state, [name]: value }));
            }
        }, [value, name, storeApi]);
        useEffect(() => {
            if (onChange) {
                return storeApi.subscribe((state, prevState) => {
                    if (state[name] !== prevState[name]) {
                        onChange(state[name]);
                    }
                });
            }
        }, [onChange, name, storeApi]);
        return null;
    }
    return { Provider, SyncPropWithStore, useStore, useStoreApi };
}
//# sourceMappingURL=context-store.js.map